import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';


class review12_3 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>3</h1><br></br>
                           
                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5><h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. ปีปกติสุรทินในระบบสุริยคติมีกี่วัน</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.354 วัน</h5>
                           <h5 className="textreviewT">ข.365 วัน</h5>
                           <h5 className="textreviewF">ค.366 วัน</h5>
                        </Form>

                        <h5 className="textreview">3. มนุษย์เริ่มเข้าสู่ยุคประวัติศาสตร์เมื่อไร</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.เมื่อตั้งถิ่นฐานถาวร</h5>
                           <h5 className="textreviewF">ข.เมื่อมีระบบการปกครอง</h5>
                           <h5 className="textreviewT">ค.เมื่อรู้จักใช้ตัวหนังสือบันทึกเรื่องราว</h5>
                        </Form>

                        <h5 className="textreview">4. ปีอธิกมาสทางจันทรคติทำให้ปีนั้นมีวันเพิ่มจากปกติอีกกี่วัน</h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. 1 วัน</h5>
                           <h5 className="textreviewF">ข. 29 วัน</h5>
                           <h5 className="textreviewT">ค. 30 วัน</h5>
                        </Form>

                        <h5 className="textreview">5. สภาพภูมิประเทศของสุโขทัยมีลักษณะเด่นตรงตามข้อใด</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เป็นศูนย์กลางเชื่อมต่อกับเมืองอื่นได้สะดวก</h5>
                           <h5 className="textreviewF">ข. มีที่ราบกว้างใหญ่รองรับการขยายตัวของเมือง</h5>
                           <h5 className="textreviewF">ค. พื้นที่เป็นที่ราบลุ่มน้ำท่าอุดมสมบูรณ์</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review12_3